import { toast } from 'react-toastify';

export const getMediaURL = (
  type: string,
  URL: string,
  name: string,
  user: string
) => {
  switch (type) {
    case 'linkedin':
      return `https://www.linkedin.com/feed/?shareActive=true&text=${encodeURIComponent(
        getSocialMediaBody(name, URL)
      )}`;
    case 'whatsapp':
      return `https://api.whatsapp.com/send?text=${encodeURIComponent(
        getSocialMediaBody(name, URL)
      )}`;
    case 'email':
      return `mailto:?subject=${encodeURIComponent(
        getEmailSubject(name, user)
      )}&body=${encodeURIComponent(getEmailBody(name, user, URL))}`;
    case 'twitter':
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        getSocialMediaBody(name, URL)
      )}`;

    default:
      return '';
  }
};

export const copyToClip = async (URL: string) => {
  navigator.clipboard.writeText(URL).then(() => toast.success('Link Copied'));
};

const getEmailBody = (name: string, user: string, URL: string) => `
Dear  [Recipient's Name],
We hope you are doing great ☀️ 
${user} has just shared the profile of ${name} on Covalo. 
Access it under the following link ${URL}. 
Covalo is the largest ingredients platform in the consumer goods industry and helps 5.000+ brands in 140+ countries launch sustainable, transparent, and innovative products faster to market by helping them better connect, collaborate, and (soon) transact with the right supplier.
You can create your free account under the following link (${process.env.REACT_APP_COVALO_FRONTOFFICE}/register) to discover more than 80.000 ingredients.
Happy exploring. 

Your ${user}`;

const getEmailSubject = (name: string, user: string) =>
  `${user} has just shared the profile of ${name} on Covalo.`;

const getSocialMediaBody = (
  name: string,
  URL: string
) => `I've found ${name} on Covalo, the largest ingredients platform for the consumer goods industry! Access it under the following link ${URL} You can create your free account under the following link (${process.env.REACT_APP_COVALO_FRONTOFFICE}/register) to discover more than 80.000 ingredients.
`;
